// dev/app-skeleton/src/lib/current-user.ts
// 当前已解锁用户的 user_id 持久化（kv 表）+ React hook。
// 真实流程：Unlock → /api/auth/me 返回 user_id → setCurrentUserId(uuid)。
// D13 期暂用 mock：Unlock 第一次解锁时如果没有 user_id 就生成一个 UUID 持久化进 IDB，
// 这样后续 AAD 绑定（entry/draft/backup）跨刷新仍然稳定，符合 E2EE 语义。
import { useEffect, useState } from "react";
import { kvGet, kvSet } from "./db";
const KV_KEY = "current_user_id";
export async function getCurrentUserId() {
    const existing = await kvGet(KV_KEY);
    if (existing)
        return existing;
    // 首次：生成稳定 UUID
    const uid = crypto.randomUUID();
    await kvSet(KV_KEY, uid);
    return uid;
}
export async function setCurrentUserId(uid) {
    await kvSet(KV_KEY, uid);
}
/** React hook：异步加载 + 缓存 user_id；未就绪时返回 null。 */
export function useCurrentUserId() {
    const [uid, setUid] = useState(null);
    useEffect(() => {
        let alive = true;
        getCurrentUserId().then((v) => { if (alive)
            setUid(v); });
        return () => { alive = false; };
    }, []);
    return uid;
}
